"use client";

import React, { useMemo, useRef } from "react";
import style from "./Passionate.module.scss";
import { MagneticChipButton } from "@/components/common/Buttons/MagneticChipButton/MagneticChipButton";
import WordsFlip from "@/components/common/WordsFlip/WordsFlip";
import { useLocale } from "next-intl";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";

export const Passionate = ({ messages }) => {
  const words = useMemo(() => messages?.words_passionate, [messages]);
  const challengeRef = useRef(null);
  const locale = useLocale();
  const hrefLink = locale === "en" ? "/projects" : "/proyectos";

  return (
    <section className={style.sectionContainer} ref={challengeRef}>
      <div className={`${style.containerCenter} container`}>
        <div className={style.textContainer}>
          <div>
            <TitleAnimation
              messages={{
                first_word: messages.first_words,
              }}
            ></TitleAnimation>
            <WordsFlip words={words} />
          </div>
          <p>{messages.description}</p>
          <MagneticChipButton
            label={messages.button}
            variant="outline"
            onClick={() => null}
            href={hrefLink}
          />
        </div>
      </div>
    </section>
  );
};
